import { Trans, useTranslation } from 'react-i18next';
import * as z from 'zod';
import { ProgressLayout } from '../../../components/layouts/progress-layout';
import { PatchInviteForm } from '../../../components/patch-invite-form';

const schema = z.object({
  healthQuestionsStarted: z.literal(true),
});

function extractDefaults() {
  return { healthQuestionsStarted: true };
}

function transformValues({ healthQuestionsStarted }) {
  return { healthQuestionsStarted };
}

export function HealthQuestions(props) {
  const { t } = useTranslation('page.health-questions');

  return (
    <PatchInviteForm
      extractDefaults={extractDefaults}
      transformValues={transformValues}
      schema={schema}
      nextPath={props.next.path}
    >
      <ProgressLayout {...props} className="bg-primary-50" headerClassName="border-b-0">
        <h1 className="title mb-7.5 pt-1">{t('title')}</h1>
        <Trans
          i18nKey="text"
          ns="page.health-questions"
          components={{
            p: <p />,
            strong: <strong className="font-semibold" />,
          }}
        />
      </ProgressLayout>
    </PatchInviteForm>
  );
}
